import axios from "axios"
import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_DETAILS_FAIL,
  USER_DETAILS_RESET,
  USER_UPDATE_PROFILE_REQUEST,
  USER_UPDATE_PROFILE_SUCCESS,
  USER_UPDATE_PROFILE_FAIL,
  USER_CREATE_FEEDBACK_REQUEST,
  USER_CREATE_FEEDBACK_SUCCESS,
  USER_CREATE_FEEDBACK_FAIL,
  USER_FEEDBACK_REQUEST,
  USER_FEEDBACK_SUCCESS,
  USER_FEEDBACK_FAIL,

  // USER_LIST_REQUEST,
  // USER_LIST_SUCCESS,
  // USER_LIST_FAIL,
  USER_LIST_RESET,
  // USER_DELETE_REQUEST,
  // USER_DELETE_SUCCESS,
  // USER_DELETE_FAIL,
  // USER_UPDATE_REQUEST,
  // USER_UPDATE_SUCCESS,
  // USER_UPDATE_FAIL,
} from "../constants/userConstants"

import { ORDER_LIST_MY_RESET } from "../constants/orderConstants"

export const LocaltoDataBase = () => async (dispatch, getState) => {
  const {
    userLogin: { userInfo },
  } = getState()
  const config2 = {
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${userInfo.token}`,
    },
  }
  const loaclCartItems = localStorage.getItem("cartItems")

  if (loaclCartItems) {
    const { data } = await axios.post(
      `/api/orders/addcart/`,
      loaclCartItems,
      config2
    )
    localStorage.removeItem("cartItems")
    // localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems))
  }
}

export const login = (email, password) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_LOGIN_REQUEST,
    })

    const config = {
      headers: {
        "Content-type": "application/json",
      },
    }

    const { data } = await axios.post(
      "/api/users/login/",
      { email: email, password: password },
      config
    )

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data,
    })
    localStorage.setItem("userInfo", JSON.stringify(data))
    dispatch(LocaltoDataBase())
  } catch (error) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    })
  }
}

export const logout = () => (dispatch) => {
  localStorage.removeItem("userInfo")
  dispatch({ type: USER_LOGOUT })
  dispatch({ type: USER_DETAILS_RESET })
  dispatch({ type: ORDER_LIST_MY_RESET })
  dispatch({ type: USER_LIST_RESET })
}

export const registerUser = (userData) => async (dispatch) => {
  try {
    dispatch({
      type: USER_REGISTER_REQUEST,
    })

    const config = {
      headers: {
        "Content-type": "application/json",
      },
    }

    const { data } = userData.uid
      ? await axios.post(
          "/api/users/register/",
          {
            name: userData.displayName ?? userData.email,
            email: userData.email,
            google: true,
            OTP: false,
          },
          config
        )
      : userData.email && userData.password
      ? await axios.post(
          "/api/users/register/",
          {
            name: userData.name,
            number: userData.number,
            email: userData.email,
            password: userData.password,
            google: false,
            OTP: false,
          },
          config
        )
      : await axios.post(
          "/api/users/register/",
          {
            email: userData.number,
            google: false,
            OTP: true,
          },
          config
        )

    // const { data } = await axios.post(
    //   "/api/users/register/",
    //   { userData },
    //   config
    // );

    dispatch({
      type: USER_REGISTER_SUCCESS,
      payload: data,
    })

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data,
    })

    localStorage.setItem("userInfo", JSON.stringify(data))
    dispatch(LocaltoDataBase())
  } catch (error) {
    dispatch({
      type: USER_REGISTER_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    })
  }
}

export const getUserDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_DETAILS_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`/api/users/${id}/`, config)

    dispatch({
      type: USER_DETAILS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: USER_DETAILS_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    })

    if (error.response && error.response.status === 401) {
      logout()
    }
  }
}

export const updateUserProfile = (user) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_UPDATE_PROFILE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = user.address
      ? await axios.put(
          `/api/users/profile/update/`,
          {
            houseNo: user.houseNo,
            address: user.address,
            city: user.city,
            pincode: user.pincode,
            state: user.state,
            number: user.number,
            email: user.email,
            name: user.name,
            ...user, // spread to include any additional fields
          },
          config
        )
      : await axios.put(
          `/api/users/profile/update/`,
          { name: user.name, email: user.email, number: user.number, ...user },
          config
        )

    dispatch({
      type: USER_UPDATE_PROFILE_SUCCESS,
      payload: data,
    })

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data,
    })

    localStorage.setItem("userInfo", JSON.stringify(data))
    return data
  } catch (error) {
    dispatch({
      type: USER_UPDATE_PROFILE_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    })
  }
}

export const createFeedback = (feedback) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_CREATE_FEEDBACK_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()
    const config = {
      headers: {
        "Content-type": "multipart/form-data",
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(
      `/api/users/create-feedback/`,
      feedback,
      config
    )

    dispatch({
      type: USER_CREATE_FEEDBACK_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: USER_CREATE_FEEDBACK_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    })
  }
}

export const listFeedbacks = () => async (dispatch) => {
  try {
    dispatch({ type: USER_FEEDBACK_REQUEST })

    const { data } = await axios.get(`/api/users/feedback/`)

    dispatch({
      type: USER_FEEDBACK_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: USER_FEEDBACK_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    })
  }
}
